<div class="row">
    <div class="product-hero">
        <product-image class="image-wrapper"
            [imageClass]="'large-thumbnail'"
            [images]="viewProduct.productImages"
            [imageType]="'productImage'"
            [imageSize]="(viewProduct.productImages.length > 1)? 'XS': 'TH'"
            [imageOrder]="0"></product-image>

        @if (viewProduct.canAddToCart) {
            <a class="product-name" (click)="setActiveOrderView()"
               [routerLink]="viewProduct.mhpId ? [MHP_BUILD_ROUTE] : [PRODUCT_ROUTE, ProductUtil.convertUsanaIdToDash(viewProduct.usanaId)]"
               [queryParams]="viewProduct.mhpId ? {type: 'edit', packId: viewProduct.mhpId} : {}"
               [innerHTML]="viewProduct.name"></a>
        } @else {
            <span class="product-name" [innerHTML]="viewProduct.name"></span>
        }

        <span class="product-info hidden-desktop">{{viewProduct.totalPrice | usanacurrency: currencyCode | async}}</span>
        <span class="tooltip-wrapper"
              [tooltip]=" 'cart.order.history.cannot.add.product' | translate "
              [isDisabled]="viewProduct.canAddToCart">
            <button class="btn btn-warning"
                    (click)="itemAdded.emit(viewProduct)"
                    [disabled]="!viewProduct.canAddToCart || isAddingToCart">
                <span translate="cart.order.history.add.to.cart"></span>
            </button>
        </span>
    </div>
    <div class="product-row">
        @for (displayAttr of displayAttributes; track $index) {
            <span class="product-info">
                @if (displayAttr.isCurrency) {
                    <span>{{viewProduct[displayAttr.name] | usanacurrency: currencyCode | async}}</span>
                } @else {
                    <span>{{viewProduct[displayAttr.name]}}</span>
                }
            </span>
        }
    </div>
</div>
